<template>
  <div class="company-form">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="180px"
      inline-message
      class="demo-ruleForm"
      size="mini"
    >
      <!-- 企业注册名称 -->
      <el-form-item label="企业注册名称：" prop="companyRegistrationName" :error="errorMsg.companyRegistrationName">
        <el-input v-model="ruleForm.companyRegistrationName" :disabled="status === 1" @input="_limitLen(undefined, undefined, key = 'companyRegistrationName', len = 200)"></el-input>
        <div v-show="reasons.companyRegistrationName" class="reason">驳回原因：{{ reasons.companyRegistrationName }}</div>
      </el-form-item>
      <el-form-item>
        <div class="download-tips">
          请确保填写的公司<span class="highlight">注册名称</span>与您的<span v-if="!isOverseas" class="highlight">营业执照</span><span v-else class="highlight">企业注册证</span>名称完全一致，包括<span class="highlight">简繁体</span>、<span class="highlight">英文大小</span>及<span class="highlight">空格</span>。
        </div>
      </el-form-item>

      <!-- 统一社会信用代码 -->
      <el-form-item :label="!isOverseas ? '统一社会信用代码：' : '企业注册证编号：'" prop="companyUnifiedSocialCreditCode" :error="errorMsg.companyUnifiedSocialCreditCode">
        <el-input
          v-if="!isOverseas"
          v-model="ruleForm.companyUnifiedSocialCreditCode"
          :disabled="status === 1"
          @input="_limitLen(undefined, undefined, key = 'companyUnifiedSocialCreditCode', len = 18)"
        ></el-input>
        <el-input v-else v-model="ruleForm.companyUnifiedSocialCreditCode" :disabled="status === 1"></el-input>
        <div v-show="reasons.companyUnifiedSocialCreditCode" class="reason">驳回原因：{{ reasons.companyUnifiedSocialCreditCode }}</div>
      </el-form-item>
      <el-form-item>
        <div class="download-tips">
          <span v-if="!isOverseas">请按照营业执照上的注册号进行填写</span>
          <span v-else>请按照海外公司注册证上的编号进行填写</span>
        </div>
      </el-form-item>

      <!-- 企业注册地址 -->
      <el-form-item
        v-if="!isOverseas"
        label="企业注册地址："
        class="form-address"
        required
      >
        <el-col :span="8">
          <el-form-item prop="companyProvince" :error="errorMsg.companyProvince">
            <el-select
              v-model="ruleForm.companyProvince"
              :disabled="status === 1"
              placeholder="请选择"
              @change="provinceChange(ruleForm.companyProvince)"
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.region_id"
                :label="item.region_name"
                :value="item.region_id.toString()"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="1" style="textAlign: center">-</el-col>
        <el-col :span="8">
          <el-form-item prop="companyCity" :error="errorMsg.companyCity">
            <el-select
              v-model="ruleForm.companyCity"
              :disabled="status === 1"
              placeholder="请选择"
              class="select"
              @change="cityChange(ruleForm.companyCity)"
            >
              <el-option
                v-for="item in cityOptions"
                :key="item.region_id"
                :label="item.region_name"
                :value="item.region_id.toString()"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="1" style="textAlign: center">-</el-col>
        <el-col :span="8">
          <el-form-item prop="companyDistrict" :error="errorMsg.companyDistrict">
            <el-select
              v-model="ruleForm.companyDistrict"
              :disabled="status === 1"
              placeholder="请选择"
              class="select"
            >
              <el-option
                v-for="item in districtOptions"
                :key="item.region_id"
                :label="item.region_name"
                :value="item.region_id.toString()"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="isOverseas ? '企业注册地址：' : null" prop="companyAddress" :error="errorMsg.companyAddress">
        <el-input
          v-model="ruleForm.companyAddress"
          :disabled="status === 1"
          :placeholder="!isOverseas ? '请填写与您营业执照上相同地址' : '请填写企业注册使用的海外地址'"
          @input="_limitLen(undefined, undefined, key = 'companyAddress', len = 50)"
        ></el-input>
        <div v-show="reasons.companyAddress" class="reason">驳回原因：{{ reasons.companyAddress }}</div>
      </el-form-item>

      <!-- 成立日期 -->
      <el-form-item
        label="成立日期："
        prop="companyEstablishDate"
        :error="errorMsg.companyEstablishDate"
        required
      >
        <el-date-picker
          v-model="ruleForm.companyEstablishDate"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          prefix-icon="el-icon-date"
          :disabled="status === 1"
          :picker-options="{disabledDate(time) {
            return time.getTime() > Date.now()
          }}"
        ></el-date-picker>
        <div v-show="reasons.companyEstablishDate" class="reason">驳回原因：{{ reasons.companyEstablishDate }}</div>
      </el-form-item>

      <!-- 注册资金 -->
      <el-form-item
        label="注册资金："
        prop="companyRegisteredCapital"
        class="wd160"
        :error="errorMsg.companyRegisteredCapital"
      >
        <el-input v-model="ruleForm.companyRegisteredCapital" :disabled="status === 1" style="margin-right:19px"></el-input>万
        <div v-show="reasons.companyRegisteredCapital" class="reason">驳回原因：{{ reasons.companyRegisteredCapital }}</div>
      </el-form-item>

      <!-- 经营期限 -->
      <el-form-item class="form2item mgb0" label="经营期限：" required>
        <el-col :span="6">
          <el-form-item prop="companyOperatingPeriodStart" :error="errorMsg.companyOperatingPeriodStart">
            <el-date-picker
              v-model="ruleForm.companyOperatingPeriodStart"
              :disabled="status === 1 || ruleForm.companyOperatingPeriodIsLongTermEffective"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              prefix-icon="el-icon-date"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="1" style="textAlign: center">至</el-col>
        <el-col :span="6">
          <el-form-item prop="companyOperatingPeriodEnd" :error="errorMsg.companyOperatingPeriodEnd">
            <el-date-picker
              v-model="ruleForm.companyOperatingPeriodEnd"
              :disabled="status === 1 || ruleForm.companyOperatingPeriodIsLongTermEffective"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              :picker-options="{disabledDate(time) {
                return time.getTime() < (_dateToDateTime(ruleForm.companyOperatingPeriodStart) > Date.now() ? (_dateToDateTime(ruleForm.companyOperatingPeriodStart) + 86400000) : Date.now())
              }}"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="3" style="marginLeft: 10px">
          <el-form-item prop="companyOperatingPeriodIsLongTermEffective" :error="errorMsg.companyOperatingPeriodIsLongTermEffective">
            <el-checkbox v-model="ruleForm.companyOperatingPeriodIsLongTermEffective" :disabled="status === 1">长期有效</el-checkbox>
          </el-form-item>
        </el-col>
        <div v-show="reasons.companyOperatingPeriod" class="reason">驳回原因：{{ reasons.companyOperatingPeriod }}</div>
      </el-form-item>

      <!-- 经营范围 -->
      <el-form-item label="经营范围：" prop="companyBusinessScope" :error="errorMsg.companyBusinessScope">
        <el-input
          v-model="ruleForm.companyBusinessScope"
          :disabled="status === 1"
          type="textarea"
          @input="_limitLen(undefined, undefined, key = 'companyBusinessScope', len = 500)"
        ></el-input>
        <div v-show="reasons.companyBusinessScope" class="reason">驳回原因：{{ reasons.companyBusinessScope }}</div>
      </el-form-item>

      <!-- 公司规模 -->
      <el-form-item label="公司规模：" prop="companyEmployeeSize" :error="errorMsg.companyEmployeeSize">
        <el-select
          v-model="ruleForm.companyEmployeeSize"
          :disabled="status === 1"
          placeholder="请选择"
          class="select"
        >
          <el-option
            v-for="item in scaleOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <div v-show="reasons.companyEmployeeSize" class="reason">驳回原因：{{ reasons.companyEmployeeSize }}</div>
      </el-form-item>

      <!-- 纳税人类型 -->
      <el-form-item
        v-if="!isOverseas"
        label="纳税人类型："
        prop="companyTaxpayerType"
        :error="errorMsg.companyTaxpayerType"
      >
        <el-select
          v-model="ruleForm.companyTaxpayerType"
          :disabled="status === 1"
          placeholder="请选择"
          class="select"
          @change="taxpayerTypeChange"
        >
          <el-option
            v-for="item in taxpayerOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <div v-show="reasons.companyTaxpayerType" class="reason">驳回原因：{{ reasons.companyTaxpayerType }}</div>
      </el-form-item>

      <!-- 纳税类型税码 -->
      <el-form-item
        v-if="!isOverseas"
        label="纳税类型税码："
        prop="companyTaxpayerTypeCode"
        :error="errorMsg.companyTaxpayerTypeCode"
      >
        <el-select
          v-model="ruleForm.companyTaxpayerTypeCode"
          :disabled="status === 1"
          placeholder="请选择"
          class="select"
        >
          <el-option
            v-for="item in taxCodeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <div v-show="reasons.companyTaxpayerTypeCode" class="reason">驳回原因：{{ reasons.companyTaxpayerTypeCode }}</div>
      </el-form-item>

      <!-- 企业营业执照 -->
      <el-form-item
        :label="!isOverseas ? '企业营业执照：' : '企业注册证：'"
        prop="companyBusinessLicenseObjectId"
        :inline-message="false"
        :error="errorMsg.companyBusinessLicenseObjectId"
      >
        <el-upload
          v-model="ruleForm.companyBusinessLicenseObjectId"
          class="avatar-uploader"
          :class="[ruleForm.companyBusinessLicenseObjectId ? 'active' : 'inactive']"
          :disabled="status === 1"
          action=""
          accept="image/*"
          :show-file-list="false"
          :http-request="ctx => imageUpload(ctx, 'ruleForm', 'ruleForm','companyBusinessLicenseObjectId')"
          :before-upload="beforeImageUpload()"
        >
          <div v-if="status !== 1 && ruleForm.companyBusinessLicenseObjectId" class="btn-close" @click.stop="removeImage(ruleForm, 'companyBusinessLicenseObjectId')">
            <img src="@/assets/img/icon-close.png">
          </div>
          <img v-if="ruleForm.companyBusinessLicenseObjectId" :src="encodeImgURl('ruleForm', 'companyBusinessLicenseObjectId')" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div v-show="reasons.companyBusinessLicenseObjectId" class="reason uploader-reason">驳回原因：{{ reasons.companyBusinessLicenseObjectId }}</div>
        <span class="download-tips">
          图片尺寸<span class="highlight">800px*800px</span>以上，图片大小不超过<span class="highlight">1M</span>，格式<span class="highlight">png/jpg/jpeg</span>
          ，请保证<span v-if="!isOverseas" class="highlight">企业营业执照</span><span v-else class="highlight">企业注册证</span>信息清晰可见，需在扫描件上加盖<span class="highlight">红章</span>后上传。
        </span>
      </el-form-item>

      <!-- 银行开户许可证 -->
      <el-form-item
        label="银行开户许可证："
        prop="companyOpeningBankAccountPermissionObjectId"
        :inline-message="false"
        :error="errorMsg.companyOpeningBankAccountPermissionObjectId"
      >
        <el-upload
          v-model="ruleForm.companyOpeningBankAccountPermissionObjectId"
          class="avatar-uploader"
          :class="[ruleForm.companyOpeningBankAccountPermissionObjectId ? 'active' : 'inactive']"
          action=""
          accept="image/*"
          :disabled="status === 1"
          :show-file-list="false"
          :http-request="(ctx) => imageUpload(ctx, 'ruleForm', 'ruleForm', 'companyOpeningBankAccountPermissionObjectId')"
          :before-upload="beforeImageUpload()"
        >
          <div v-if="status !== 1 && ruleForm.companyOpeningBankAccountPermissionObjectId" class="btn-close" @click.stop="removeImage(ruleForm, 'companyOpeningBankAccountPermissionObjectId')">
            <img src="@/assets/img/icon-close.png">
          </div>
          <img v-if="ruleForm.companyOpeningBankAccountPermissionObjectId" :src="encodeImgURl('ruleForm', 'companyOpeningBankAccountPermissionObjectId')" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div v-show="reasons.companyOpeningBankAccountPermissionObjectId" class="reason uploader-reason">驳回原因：{{ reasons.companyOpeningBankAccountPermissionObjectId }}</div>
        <span class="download-tips">图片尺寸<span class="highlight">800px*800px</span>以上，图片大小不超过<span class="highlight">1M</span>，格式<span class="highlight">png/jpg/jpeg</span>，请保证<span class="highlight">银行开户许可证</span>信息清晰可见，需在扫描件上加盖<span class="highlight">红章</span>后上传。</span>
      </el-form-item>

      <!-- 开户总行 -->
      <el-form-item
        v-if="!isOverseas"
        label="开户总行："
        prop="depositBankName"
        style="width: 300px"
        :error="errorMsg.depositBankName"
      >
        <el-select
          v-model="ruleForm.depositBankName"
          :disabled="status === 1"
          placeholder="请选择"
          class="select"
        >
          <el-option
            v-for="item in bankList"
            :key="item.label"
            :label="item.label"
            :value="item.label"
          ></el-option>
        </el-select>
        <div v-show="reasons.depositBankName" class="reason">驳回原因：{{ reasons.depositBankName }}</div>
      </el-form-item>

      <!-- 开户支行 -->
      <el-form-item
        v-if="!isOverseas"
        label="开户支行："
        prop="subbranchBankName"
        :error="errorMsg.subbranchBankName"
      >
        <el-input v-model="ruleForm.subbranchBankName" :disabled="status === 1"></el-input>
        <div v-show="reasons.subbranchBankName" class="reason">驳回原因：{{ reasons.subbranchBankName }}</div>
        <span style="margin-left:10px">填写格式：<span class="highlight">XX银行 XX支行</span></span>
      </el-form-item>

      <!-- 开户银行账号 -->
      <el-form-item
        v-if="!isOverseas"
        label="开户银行账号："
        prop="bankAccount"
        :error="errorMsg.bankAccount"
      >
        <el-input v-model="ruleForm.bankAccount" :disabled="status === 1"></el-input>
        <div v-show="reasons.bankAccount" class="reason">驳回原因：{{ reasons.bankAccount }}</div>
      </el-form-item>

      <!-- 开户银行所在省市 -->
      <el-form-item v-if="!isOverseas" label="开户银行所在省市：" required>
        <div class="bank-addr">
          <el-form-item prop="bankProvince" :error="errorMsg.bankProvince">
            <el-select
              v-model="ruleForm.bankProvince"
              :disabled="status === 1"
              placeholder="请选择"
              @change="bankProvinceChange(ruleForm.bankProvince)"
            >
              <el-option
                v-for="item in bankProvinceOptions"
                :key="item.region_id"
                :label="item.region_name"
                :value="item.region_id.toString()"
              ></el-option>
            </el-select>
          </el-form-item>
          <span class="label">省</span>
          <el-form-item prop="bankCity" :error="errorMsg.bankCity">
            <el-select
              v-model="ruleForm.bankCity"
              :disabled="status === 1"
              placeholder="请选择"
              class="select"
            >
              <el-option
                v-for="item in bankCityOptions"
                :key="item.region_id"
                :label="item.region_name"
                :value="item.region_id.toString()"
              ></el-option>
            </el-select>
          </el-form-item>
          <span class="label">市</span>
        </div>
        <div v-show="reasons.bankProvince || reasons.bankCity" class="reason">驳回原因：{{ [reasons.bankProvince, reasons.bankCity].join(',') }}</div>
      </el-form-item>
      <el-form-item
        v-if="!isOverseas"
        label="开通平安银行子账户："
        prop="subAccount"
        style="margin-bottom: 0;"
      >
        <el-radio v-model="ruleForm.subAccount" :label="true" :disabled="status === 1">
          同意&nbsp;&nbsp;<a
            href="https://my.orangebank.com.cn/orgLogin/hd/act/jianzb/jzbxy.html"
            rel="noreferrer"
            target="_blank"
            style="color: #457bfc"
          >查看协议</a>
        </el-radio>
      </el-form-item>
      <el-form-item
        v-if="!isOverseas"
        label=""
      >
        <span>开通平安银行子账户用于实时分账，商户自提现结算金额</span>
      </el-form-item>

      <!-- 底部按钮 -->
      <el-form-item class="form-footer">
        <el-button v-if="status === 0" class="mi-primary-plain" @click="lastEachStep()">上一步</el-button>
        <el-button
          v-if="status === 0"
          class="mi-primary"
          :disabled="saveBtnDisabled"
          @click="submitForm('ruleForm')"
        >
          保存并下一步
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import { processMixin } from '@/common/mixin'
import { getAddress, validateMerchantBasic, validateOverseaMerchantBasic } from '@/api/merchant'
import { shallowMerge, deepCopy } from '@/utils'
import bankList from '@/common/banklist'
import companyRules from './rules/company'

export default {
  mixins: [processMixin],
  props: {
    // 表单状态，0:填写阶段 1:禁止修改 2:可以修改
    status: {
      type: Number,
      default: 0
    }
  },
  data() {
    const isOverseas = this.$store.state.isOverseas
    const rules = {
      companyRegistrationName: companyRules.companyRegistrationName(),
      companyEstablishDate: companyRules.companyEstablishDate(),
      companyProvince: companyRules.companyProvince(isOverseas),
      companyDistrict: companyRules.companyDistrict(isOverseas),
      companyCity: companyRules.companyCity(isOverseas),
      companyAddress: companyRules.companyAddress(),
      companyUnifiedSocialCreditCode: companyRules.companyUnifiedSocialCreditCode(isOverseas),
      companyRegisteredCapital: companyRules.companyRegisteredCapital(),
      companyOperatingPeriodStart: companyRules.companyOperatingPeriodStart(),
      companyOperatingPeriodEnd: companyRules.companyOperatingPeriodEnd(),
      companyBusinessScope: companyRules.companyBusinessScope(),
      companyEmployeeSize: companyRules.companyEmployeeSize(),
      companyTaxpayerType: companyRules.companyTaxpayerType(isOverseas),
      companyTaxpayerTypeCode: companyRules.companyTaxpayerTypeCode(isOverseas),
      companyBusinessLicenseObjectId: companyRules.companyBusinessLicenseObjectId(isOverseas),
      companyOpeningBankAccountPermissionObjectId: companyRules.companyOpeningBankAccountPermissionObjectId(),
      depositBankName: companyRules.depositBankName(),
      subbranchBankName: companyRules.subbranchBankName(),
      bankAccount: companyRules.bankAccount(),
      subAccount: [{ required: true, trigger: 'change', message: '请勾选同意开通平安银行子账户' }]
    }
    return {
      rules,
      bankList,
      saveBtnDisabled: false,
      provinceOptions: [],
      cityOptions: [],
      districtOptions: [],
      bankProvinceOptions: [],
      bankCityOptions: [],
      scaleOptions: [
        { value: '1', label: '0-50' },
        { value: '2', label: '50-100' },
        { value: '3', label: '100-500' },
        { value: '4', label: '500-1000' },
        { value: '5', label: '1000以上' }
      ],
      taxpayerOptions: [
        { value: '1', label: '一般纳税人' },
        { value: '2', label: '小规模纳税人' }
      ],
      value: '',
      ruleForm: {
        companyRegistrationName: '',
        companyUnifiedSocialCreditCode: '',
        companyProvince: '',
        companyCity: '',
        companyDistrict: '',
        companyAddress: '',
        companyEstablishDate: '',
        companyRegisteredCapital: '',
        companyEmployeeSize: '',
        companyOperatingPeriodStart: '',
        companyOperatingPeriodEnd: '',
        companyOperatingPeriodIsLongTermEffective: false,
        companyBusinessScope: '',
        companyTaxpayerType: '',
        companyTaxpayerTypeCode: '',
        companyBusinessLicenseObjectId: '',
        companyOpeningBankAccountPermissionObjectId: null,
        depositBankName: null,
        subbranchBankName: null,
        bankAccount: null,
        bankProvince: null,
        bankCity: null,
        subAccount: null
      },
      errorMsg: {
        companyRegistrationName: null,
        companyUnifiedSocialCreditCode: null,
        companyProvince: null,
        companyCity: null,
        companyDistrict: null,
        companyAddress: null,
        companyEstablishDate: null,
        companyRegisteredCapital: null,
        companyOperatingPeriodStart: null,
        companyOperatingPeriodEnd: null,
        companyOperatingPeriodIsLongTermEffective: null,
        companyBusinessScope: null,
        companyEmployeeSize: null,
        companyTaxpayerType: null,
        companyTaxpayerTypeCode: null,
        companyBusinessLicenseObjectId: null,
        companyOpeningBankAccountPermissionObjectId: null,
        depositBankName: null,
        subbranchBankName: null,
        bankAccount: null,
        bankProvince: null,
        bankCity: null
      },
      reasons: {
        companyRegistrationName: null,
        companyUnifiedSocialCreditCode: null,
        companyAddress: null,
        companyEstablishDate: null,
        companyRegisteredCapital: null,
        companyOperatingPeriod: null,
        companyBusinessScope: null,
        companyEmployeeSize: null,
        companyTaxpayerType: null,
        companyTaxpayerTypeCode: null,
        companyBusinessLicenseObjectId: null,
        companyOpeningBankAccountPermissionObjectId: null,
        depositBankName: null,
        subbranchBankName: null,
        bankAccount: null,
        bankProvince: null,
        bankCity: null
      }
    }
  },
  computed: {
    ...mapState({
      contactIndex: state => state.contactIndex,
      merchantData: state => state.merchantData,
      isOverseas: state => state.isOverseas
    }),
    taxCodeOptions() {
      switch (this.ruleForm.companyTaxpayerType) {
        case '1':
          return [
            { value: '6', label: '6%' },
            { value: '9', label: '9%' },
            { value: '13', label: '13%' }
          ]
        case '2':
          return [{ value: '3', label: '3%' }]
        default:
          return []
      }
    }
  },
  watch: {
    'ruleForm.companyOperatingPeriodIsLongTermEffective'(newVal) {
      if (newVal) {
        this.rules.companyOperatingPeriodStart = { required: false }
        this.rules.companyOperatingPeriodEnd = { required: false }
        this.$refs.ruleForm.clearValidate([
          'companyOperatingPeriodStart',
          'companyOperatingPeriodEnd'
        ])
      } else {
        this.rules.companyOperatingPeriodStart = [{
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }]
        this.rules.companyOperatingPeriodEnd = [{
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }]
      }
    }
  },
  mounted() {
    if (this.merchantData && this.merchantData.company) {
      const data = this.merchantData.company
      // 根据返回的数据处理有效期
      this.ruleForm.companyOperatingPeriodIsLongTermEffective = data.companyOperatingPeriodIsLongTermEffective === 'Y'
      const expendKey = ['companyOperatingPeriodIsLongTermEffective']
      this.ruleForm.subAccount = true
      for (let key in data) {
        for (let key1 in this.ruleForm) {
          if (!expendKey.includes(key) && key === key1) {
            this.ruleForm[key] = data[key]
            if (key === 'companyTaxpayerType' && this.ruleForm[key] === '0') this.ruleForm[key] = ''
            else if (key === 'companyTaxpayerTypeCode' && this.ruleForm[key] === '0') this.ruleForm[key] = ''
          }
        }
      }
      for (let key in this.reasons) {
        const key1 = key + 'Review'
        if (data.reviewDetail && key1 in data.reviewDetail && data.reviewDetail[key1].reject) {
          this.reasons[key] = data.reviewDetail[key1].remark
        }
      }
      this.$emit('updateReasonCount', 'companyForm', Object.values(this.reasons).reduce((acc, cur) => acc + (cur ? 1 : 0), 0))
    }
    // 拉取地址列表
    if (!this.isOverseas) {
      this.getAddressInfo().then(res => {
        if (!res.code) {
          this.provinceOptions = res.data.regions
          this.bankProvinceOptions = res.data.regions
        } else this.$message.error('服务器错误')
      })
      if (this.ruleForm.companyProvince) {
        this.getAddressInfo(this.ruleForm.companyProvince).then(res => {
          if (!res.code) {
            this.cityOptions = res.data.regions
          } else this.$message.error('服务器错误')
        })
      }
      if (this.ruleForm.companyCity) {
        this.getAddressInfo(this.ruleForm.companyCity).then(res => {
          if (!res.code) this.districtOptions = res.data.regions
          else this.$message.error('服务器错误')
        })
      }
      if (this.ruleForm.bankProvince) {
        this.getAddressInfo(this.ruleForm.bankProvince).then(res => {
          if (!res.code) {
            this.bankCityOptions = res.data.regions
          } else this.$message.error('服务器错误')
        })
      }
    }
  },
  methods: {
    ...mapMutations({
      setContactIndex: 'SET_CONTACT_INDEX',
      setMerchantData: 'SET_MERCHANT_DATA'
    }),
    // 切换纳税类型
    taxpayerTypeChange() {
      this.ruleForm.companyTaxpayerTypeCode = ''
      this.$refs.ruleForm.clearValidate(['companyTaxpayerTypeCode'])
    },
    // 图片上传成功回调
    handleBusinessLicenseSuccess(res, file) {
      const { code } = res
      if (!code) {
        this.ruleForm.companyBusinessLicenseObjectId = res.data.objectId
      } else {
        this.$message.error('上传失败，请重试')
      }
      this.$refs.ruleForm.validateField(['companyBusinessLicenseObjectId'])
    },
    handleBankAccountSuccess(res, file) {
      const { code } = res
      if (!code) {
        this.ruleForm.companyOpeningBankAccountPermissionObjectId = res.data.objectId
      } else {
        this.$message.error('上传失败，请重试')
      }
      this.$refs.ruleForm.validateField([
        'companyOpeningBankAccountPermissionObjectId'
      ])
    },
    async getAddressInfo(id = 1) {
      const address = await getAddress({ parent: id })
      return address
    },
    // 省会信息切换
    async provinceChange(id) {
      try {
        const address = await getAddress({ parent: id })
        this.cityOptions = []
        this.districtOptions = []
        if (!address.code) {
          this.ruleForm.companyCity = ''
          this.ruleForm.companyDistrict = ''
          this.cityOptions = address.data.regions
        } else {
          this.$message.error('服务器错误')
        }
      } catch (e) {
        this.$message.error(JSON.stringify(e))
      }
    },
    async cityChange(id) {
      try {
        const address = await getAddress({ parent: id })
        this.districtOptions = []
        if (!address.code) {
          this.ruleForm.companyDistrict = ''
          this.districtOptions = address.data.regions
        } else {
          this.$message.error('服务器错误')
        }
      } catch (e) {
        this.$message.error(JSON.stringify(e))
      }
    },
    async bankProvinceChange(id) {
      try {
        const address = await getAddress({ parent: id })
        this.bankCityOptions = []
        if (!address.code) {
          this.ruleForm.bankCity = ''
          this.bankCityOptions = address.data.regions
        } else {
          this.$message.error('服务器错误')
        }
      } catch (e) {
        this.$message.error(JSON.stringify(e))
      }
    },
    // 返回上一步
    lastEachStep() {
      this.setContactIndex(0)
    },
    // 提交
    submitForm(formName, jump = true) {
      return new Promise((resolve, reject) => {
        // 海外商家不校验地址
        if (this.isOverseas) {
          this.$refs[formName].validate(async valid => {
            if (valid) {
              this.saveBtnDisabled = true
              if (!(await this.validateMerchantBasic())) {
                this.saveBtnDisabled = false
                reject()
                return false
              } else {
                this.saveBtnDisabled = false
                if (jump) this.setContactIndex(2)
                resolve()
              }
            } else {
              reject()
              return false
            }
          })
        } else {
          this.$refs[formName].validate(async valid => {
            try {
              if (valid) {
                this.saveBtnDisabled = true
                if (!(await this.validateMerchantBasic())) {
                  this.saveBtnDisabled = false
                  reject()
                  return false
                } else {
                  this.saveBtnDisabled = false
                  if (jump) this.setContactIndex(2)
                  resolve()
                }
              } else {
                reject()
                return false
              }
            } catch {
              this.$message.error('请填写正确的企业注册地址')
              reject()
            }
          })
        }
      })
    },
    /**
     * @name removeImage
     * @description 删除图片按钮
     */
    removeImage(ruleForm, key) {
      ruleForm[key] = null
    },
    /**
     * @name validateMerchantBasic
     * @description 校验商户企业信息
     */
    async validateMerchantBasic() {
      const params = deepCopy(this.ruleForm)
      delete params.subAccount
      params.companyOperatingPeriodIsLongTermEffective = this.ruleForm.companyOperatingPeriodIsLongTermEffective ? 'Y' : 'N'
      const result = this.isOverseas
        ? await validateOverseaMerchantBasic(params)
        : await validateMerchantBasic(params)
      if (result.code !== 0) {
        if (result.data && result.data.fields) {
          const errorFields = result.data.fields
          for (let field in errorFields) {
            if (this.errorMsg.hasOwnProperty(field)) {
              this.errorMsg[field] = null
              this.$nextTick(() => {
                this.errorMsg[field] = errorFields[field]
              })
            }
          }
        }
        return false
      } else {
        this.setMerchantData(shallowMerge({ company: params }, this.merchantData))
        return true
      }
    }
  }
}
</script>

<style lang="less">
.company-form {
  .el-form {
    .wd160 {
      .el-input {
        width: 160px !important;
      }
    }
  }

  .form2item {
    .el-col-6 {
      width: 160px;

      .el-date-editor {
        width: 160px;
      }
    }

    .el-col-1 {
      margin: 0 10px;
    }
  }

  .form-address {
    .el-col-8 {
      width: 160px !important;

      .el-select {
        width: 160px !important;
      }
    }
  }

  .reason {
    font-size: 13px;
    line-height: 16px;
    color: #E00C0C;
    display: inline-block;
    padding-left: 20px;

    &.uploader-reason {
      position: absolute;
      top: 7px;
      left: 100px;
    }
  }

  .bank-addr {
    display: flex;
    span.label {
      padding: 0 10px;
    }
  }
}
</style>
